import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import DOMPurify from 'dompurify';
import { AppState } from '../../app.state';
import { INotifyTemplate } from '../models/notify-template.interface';
import { SharedService } from '../../core/services/shared.service';
import { UserService } from '../../shared/services/user/user.service';

@Component({
  selector: 'upsc-notify-template-preview',
  templateUrl: './notify-template-preview.component.html',
  styleUrls: ['./notify-template-preview.component.scss'],
})
export class NotifyTemplatePreviewComponent implements OnInit, OnChanges {
  @Input() template: INotifyTemplate;
  public today = Date.now();
  public isEUUser: boolean;
  public isUKUser = false;
  public showcaseItems = [];
  public message5: string;
  public message6: string;
  public message7: string;
  public message8: string;
  public countryCode: string;
  public copyrightMessage: string;
  public termsOfUseURL: string;
  public parcelProHelpURL: string;

  public constructor(private sharedService: SharedService,
                     private userService: UserService,
                     private readonly appState: AppState,
  ) {
    this.GetUserCountryCode();
    this.setCopyrightMessage();
    this.setTermsOfUseURL();
    this.setParcelProHelpURL();
  }

  public ngOnInit() {
    this.notifymessage();
  }
  public notifymessage() {
    let languageCode = sessionStorage.getItem('lang');

    const messages = {
      'DE': {
        de: {
          message5: 'UPS Capital Versicherungsvermittlung GmbH<br>Görlitzer Straße 1<br>41460 Neuss<br>Deutschland',
          message6: 'Die Gesellschaft ist im Handelsregister des Amtsgerichts Neuss unter der Handelsregisternummer HRB 16916 eingetragen. Die Geschäftsführerin der Gesellschaft ist Jo Dawn Whitlock.'
        },
        en: {
          //need to add translation for  en
          message5: 'UPS Capital Versicherungsvermittlung GmbH<br>Görlitzer Straße 1<br>41460 Neuss<br>Deutschland',
          message6: 'Die Gesellschaft ist im Handelsregister des Amtsgerichts Neuss unter der Handelsregisternummer HRB 16916 eingetragen. Die Geschäftsführerin der Gesellschaft ist Jo Dawn Whitlock.'
        }
      },
      'FR': {
        fr: {
          message5: 'Immatriculée sous le numéro 832 291 140 R.C.S. de Paris.',
          message6: 'UPS Capital Versicherungsvermittlung GmbH est enregistrée comme intermédiaire en assurance auprès de la Chambre du Commerce et de l\'Industrie de Mittlerer Niederrhein (Allemagne) sous le numéro D-GRLJ-BB3YD-12.',
          message7: 'Siège social : Görlitzer Straße 1, 41460 Neuss, Allemagne.',
          message8: 'Immatriculée au registre du commerce de Neuss sous le numéro HRB 16916.'
        },
        en: {
          //need to add translation for  en
          message5: 'Immatriculée sous le numéro 832 291 140 R.C.S. de Paris.',
          message6: 'UPS Capital Versicherungsvermittlung GmbH est enregistrée comme intermédiaire en assurance auprès de la Chambre du Commerce et de l\'Industrie de Mittlerer Niederrhein (Allemagne) sous le numéro D-GRLJ-BB3YD-12.',
          message7: 'Siège social : Görlitzer Straße 1, 41460 Neuss, Allemagne.',
          message8: 'Immatriculée au registre du commerce de Neuss sous le numéro HRB 16916.'
        }
      },

      'IT': {
        it: {
          message5: 'UPS Capital Versicherungsvermittlung GmbH con socio unico, Sede secondaria di Milano. Codice Fiscale Italiano, Partita IVA Italiana e n. Iscrizione al Registro delle Imprese di Milano 09991560963. UPS Capital Versicherungsvermittlung GmbH è autorizzata ad operare in Italia in regime di stabilimento e il numero di iscrizione all’Elenco degli intermediari comunitari annesso al Registro Unico degli Intermediari tenuto dall’IVASS è: UE00010259.',
          message6: 'Sede legale in Görlitzer Straße 1, 41460 Neuss – Germania, iscritta alla Court Register di Neuss con numero HRB 16916 e avente un capitale sociale di Euro 25.000,00, interamente versato, TAX ID No. DE 114 103 514; legale rappresentante (Managing Directore): Jo Dawn Whitlock.',
        },
        en: {
          //need to add translation for en for 
          message5: 'UPS Capital Versicherungsvermittlung GmbH con socio unico, Sede secondaria di Milano. Codice Fiscale Italiano, Partita IVA Italiana e n. Iscrizione al Registro delle Imprese di Milano 09991560963. UPS Capital Versicherungsvermittlung GmbH è autorizzata ad operare in Italia in regime di stabilimento e il numero di iscrizione all’Elenco degli intermediari comunitari annesso al Registro Unico degli Intermediari tenuto dall’IVASS è: UE00010259.',
          message6: 'Sede legale in Görlitzer Straße 1, 41460 Neuss – Germania, iscritta alla Court Register di Neuss con numero HRB 16916 e avente un capitale sociale di Euro 25.000,00, interamente versato, TAX ID No. DE 114 103 514; legale rappresentante (Managing Directore): Jo Dawn Whitlock.',
        }
      },
    };

    if (this.isUKUser) {
      this.message5 = 'UPS Capital Insurance Agency Limited is registered with Companies House, the Registrar of Companies for England and Wales, with UK establishment number 11641767.'
      this.message6 = 'UPS Capital Insurance Agency Limited’s registered office address is 2 Lotus Park, The Causeway, Staines-Upon-Thames, Middlesex, TW18 3AG, United Kingdom.';
      this.message7 = 'UPS Capital Insurance Agency Limited is an appointed representative of Crispin Speers & Partners Limited, which is authorised and regulated by the Financial Conduct Authority.';
    }
    else {
      if (languageCode !== 'en' && languageCode.toLowerCase() !== this.countryCode.toLowerCase()) {
        this.countryCode = languageCode.toUpperCase();
      }

      this.message5 = messages[this.countryCode]?.[languageCode].message5 || '';
      this.message6 = messages[this.countryCode]?.[languageCode].message6 || '';
      this.message7 = messages[this.countryCode]?.[languageCode].message7 || '';
      this.message8 = messages[this.countryCode]?.[languageCode].message8 || '';
    }


  }
  public ngOnChanges(changes: SimpleChanges) {
    this.onTemplateChanged(changes['template']);
  }

  private onTemplateChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    this.updateShowcaseItems();
    this.template.shouldDisplayShowcaseImages = !!this.showcaseItems.length;
  }

  private updateShowcaseItems() {
    if (!this.template) {
      return;
    }

    this.showcaseItems = [];

    if (this.template.ShowCaseImg1S3Url) {
      this.showcaseItems.push(this.template.ShowCaseImg1S3Url);
    }

    if (this.template.ShowCaseImg2S3Url) {
      this.showcaseItems.push(this.template.ShowCaseImg2S3Url);
    }

    if (this.template.ShowCaseImg3S3Url) {
      this.showcaseItems.push(this.template.ShowCaseImg3S3Url);
    }
  }

  openCustomerWebsite(event: MouseEvent, customerWebsite: string) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (customerWebsite) {
      const decodedUrl = decodeURIComponent(customerWebsite);
      const sanitizedUrl = DOMPurify.sanitize(decodedUrl, { IN_PLACE: true });

      if (sanitizedUrl.toLowerCase().startsWith('javascript:')) {
        return;
      }

      window.open(sanitizedUrl, '_blank');
    }
  }

  private GetUserCountryCode() {
    const user = this.appState.user$();
    this.countryCode = user?.CountryCode;
    this.isEUUser = this.userService.isEUUser(user?.CountryCode);
    this.isUKUser = this.userService.isGBUser(user);
  }
  setCopyrightMessage(){
    const user = this.appState.user$();
    this.countryCode = user?.CountryCode.toUpperCase(); // Assuming this method returns the country code
    switch (this.countryCode) {
      case 'GB':
        this.copyrightMessage = 'United Parcel Service of America, Inc. UPS, UPS Capital, the UPS brandmark, and the color brown are trademarks of United Parcel Service of America, Inc. All rights reserved.';
        break;
      case 'IT':
        this.copyrightMessage = 'United Parcel Service, UPS, UPS Capital, InsureShield, il marchio UPS e il colore marrone sono marchi di United Parcel Service of America, Inc. Tutti i diritti riservati.';
        break;
      case 'DE':
        this.copyrightMessage = 'United Parcel Service of America, Inc. UPS, UPS Capital, die Marke UPS und die Farbe Braun sind eingetragene Marken von United Parcel Service of America, Inc. Alle Recht vorbehalten.';
        break;
      case 'FR':
        this.copyrightMessage = 'United Parcel Service of America, Inc. UPS, UPS Capital, la marque figurative UPS, et la couleur marron sont des marques déposées de United Parcel Service of America, Inc. Tous droits réservés.';
        break;
      default:
        this.copyrightMessage = 'notifyTemplates.notifyTemplatePreviewMessages.message4';
        break; // Default message
    }
  }
  setTermsOfUseURL() {
    switch(this.appState.user$()?.CountryCode.toUpperCase()) {
        case "GB":
            this.termsOfUseURL = 'https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page';
            break;
        case "DE":
            this.termsOfUseURL = 'https://www.ups.com/de/de/support/shipping-support/legal-terms-conditions.page'
            break;
        case "FR":
            this.termsOfUseURL = 'https://www.ups.com/fr/fr/support/shipping-support/legal-terms-conditions.page'
            break;
        case "IT":
            this.termsOfUseURL = 'https://www.ups.com/it/it/support/shipping-support/legal-terms-conditions.page'
            break;
        default:
            this.termsOfUseURL = 'https://www.ups.com/it/it/support/shipping-support/legal-terms-conditions.page';
            break;
    }
  }
  setParcelProHelpURL() {
    switch(this.appState.user$()?.CountryCode.toUpperCase()) {
      case "GB":
          this.parcelProHelpURL = 'https://www.parcelpro.com/gb/en/home.html';
          break;
      case "DE":
          this.parcelProHelpURL = 'https://www.parcelpro.com/de/de/home.html'
          break;
      case "FR":
          this.parcelProHelpURL = 'https://www.parcelpro.com/fr/fr/home.html'
          break;
      case "IT":
          this.parcelProHelpURL = 'https://www.parcelpro.com/it/it/home.html'
          break;
      default:
          this.parcelProHelpURL = 'https://www.parcelpro.com/us/en/home.html';
          break;
  }
  }
}
